module.exports = __webpack_public_path__ + "static/media/Monica_Mang_RDA.6c99f0cf.png";